<template>
  <div class="container">

    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Connections
            </h1>
          </div>
        </div>
      </section>
    </div>

    <!-- <b-collapse class="card" :open="false">
            <div slot="trigger" slot-scope="props" class="card-header">
                <p class="card-header-title">
                    Filter
                </p>
                <a class="card-header-icon">
                    <b-tooltip label="Filter Properties" position="is-left">
                        <div class="level-right button is-primary " @click="newEvaluation()">
                            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'" />
                        </div>
                    </b-tooltip>
                </a>
            </div>
            <div class="card-content" style="background-color: #FFFFDD">
                Filter elements
            </div>
        </b-collapse> -->

    <div class="card">
      <div class=" card-header">
        <div class="card-header-title">
          Connection List
        </div>
        <a class="card-header-icon">
          <b-tooltip
            label="New Connection"
            position="is-left"
          >
            <div
              class="level-right button is-primary "
              @click="newConnection()"
            >
              <i class="fas fa-plus"></i>
            </div>
          </b-tooltip>
        </a>
      </div>
      <div class="card-content">
        <ConnectionsList />
      </div>
    </div>

    <b-modal
      :active.sync="$store.state.connectionEdit.isActive"
      has-modal-card
      :canCancel="[]"
    >
      <ConnectionEdit />
    </b-modal>

  </div>
</template>

<script>
import ConnectionsList from "@/components/connections/ConnectionsList.vue";
import ConnectionEdit from "@/components/connections/ConnectionEdit.vue";

export default {
  components: {
    ConnectionsList,
    ConnectionEdit
  },

  props: {
    open: false
  },

  methods: {
    newConnection() {
      console.log("newConnection()");
      this.$store.commit("SET_CONNECTION_EDIT_CONNECTION", {
        id: "",
        type: "",
        name: "",
        email: "",
        phone: ""
      });
      this.$store.state.connectionEdit.mode = "new";
      this.$store.commit("SET_CONNECTION_EDIT_ISACTIVE", true);
    }
  }
};
</script>

<style>
</style>
